import { CategoryModel } from 'src/types/category.model';
import * as H from 'history';
import { LocalDate } from '@js-joda/core';
import { TransactionModel } from 'src/types/transaction.model';
import { IncomeSourceModel } from 'src/types/income-source.model';
import { AccountModel } from 'src/types/account.model';
import { FullUserModel } from 'src/types/user.model';

export class TransactionsViewViewModel {
    groupUid: string;
    history: H.History;
    categories: CategoryModel[];
    startDate: LocalDate;
    endDate: LocalDate;
    filteredTransactions: TransactionModel[];
    type: string;
    incomeSource: string;
    incomeSources: IncomeSourceModel[];
    account: number;
    accounts: AccountModel[];
    showHidden: boolean;
    selectedTransactions: TransactionModel[];
    displayedTransactions: TransactionModel[];
    pageSize: number;
    page: number;
    includedAccounts: number[];
    drawerProps: any;
    user: FullUserModel;
    handleBack: () => void;
    setTransactions: (drawerProps: any, startDate?: LocalDate, endDate?: LocalDate) => Promise<any>;
    updateFilteredTransactions: (drawerProps: any) => any;
    updateDrawer: (...args: any[]) => void;
    handleReloadUser: (login?: boolean) => Promise<any>;
}
